import React from 'react';
import { CONTAINER_MODAL_ROUTES } from '@/navigators/routes';
import { ContainerModalStackParams } from '@/navigators/types';
import { ModalContainer } from '@/components/modal-container';
import { PlacesSearchComponent } from '@/components/locations/places-search-component';
import { StackScreenProps } from '@react-navigation/stack';

export type Props = StackScreenProps<
  ContainerModalStackParams,
  CONTAINER_MODAL_ROUTES.PlacesSearch
>;

export const PlacesSearchScreen: React.FC<Props> = ({ navigation, route }) => {
  const { onSelect, onSelectCurrentLocation, title, ...rest } = route.params;

  return (
    <ModalContainer navigationHeaderProps={{ title }}>
      <PlacesSearchComponent
        {...rest}
        onSelect={(...args) => {
          onSelect(...args);
          navigation.goBack();
        }}
        onSelectCurrentLocation={
          typeof onSelectCurrentLocation === 'function'
            ? (...args) => {
                onSelectCurrentLocation(...args);
                navigation.goBack();
              }
            : undefined
        }
      />
    </ModalContainer>
  );
};
